export default ($axios) => ({
  fetch(query) {
    return $axios.get('/chat/reports', { params: query });
  },
});
